import React, { Fragment, useEffect } from 'react';
import { Col, DatePicker, Form, InputNumber, message, Modal, Row, Select } from 'antd';
import { formatCurrency, parserNumber } from '../../../../utils';
import * as CommonService from '../../../../services/CommonService';
import { INVOICE_ENDPOINT } from '../../../../services/endpoint';
import { PAYMENT_METHOD } from '../../../../utils/const';
import moment from 'moment';

const { Option } = Select;

const ModalPayment = (props) => {

	const { detail, visible, setVisible, remainsToPaid, paymentHistory, setPaymentHistory, setRerender } = props;

	const { getFieldDecorator } = props.form;

	const handleSave = e => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			const body = {
				...values,
				action: 'Payment'
			}
			delete body.paymentDate;
			if (!err) {
				window.setLoading(true);
				CommonService.update(INVOICE_ENDPOINT, detail.id, body).then(res => {
					if (res.status === 200) {
						setPaymentHistory([...paymentHistory, res.data]);
						message.success('Thanh toán thành công');
						setVisible(false);
						setRerender(Math.random());
					}
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => window.setLoading(false));
			}
		});
	};

	useEffect(() => {
		if (!visible) {
			props.form.resetFields();
		}
	}, [visible]);

	const renderOptions = () => {
		return Object.keys(PAYMENT_METHOD).map(el => <Option value={el}>{PAYMENT_METHOD[el]}</Option>);
	};

	return (<Fragment>
		<Form>
			<Modal
				title="Xác nhận thanh toán"
				visible={visible}
				onOk={handleSave}
				onCancel={() => setVisible(false)}
			>
				<Row>
					<Col>
						<Form.Item label={`Phương thức thanh toán`} required>
							{getFieldDecorator(`paymentMethod`, {
								initialValue: 'CASH',
								rules: [
									{
										required: true,
										message: 'Vui lòng chọn phương thức thanh toán'
									}
								]
							})(<Select placeholder="Chọn phương thức thanh toán" style={{ width: '100%' }}>
								{renderOptions()}
							</Select>)}
						</Form.Item>
						<Form.Item label={`Số tiền`} required>
							{getFieldDecorator(`paidAmount`, {
								initialValue: remainsToPaid,
								rules: [
									{
										required: true,
										message: 'Vui lòng nhập số tiền thanh toán'
									}
								]
							})(<InputNumber placeholder="Nhập số tiền thanh toán"
															formatter={formatCurrency}
															parser={parserNumber}
															step={1000}
															min={1}
															max={remainsToPaid}
															style={{ width: '100%' }} />)}
						</Form.Item>
						<Form.Item label={`Ngày thanh toán`} required>
							{getFieldDecorator(`paymentDate`, {
								initialValue: moment(new Date(), 'YYYY-MM-DD HH:mm'),
								rules: [
									{
										required: true,
										message: 'Vui lòng chọn ngày thanh toán'
									}
								]
							})(<DatePicker
								disabled
								style={{ width: '100%' }}
								showTime={{ format: 'HH:mm' }}
								format="YYYY-MM-DD HH:mm"
								allowClear
								placeholder={'Chọn ngày thanh toán'} />)}
						</Form.Item>
					</Col>
				</Row>
			</Modal>
		</Form>
	</Fragment>);
};

export default Form.create({ name: 'ModalPayment' })(ModalPayment);

